import {scnv}  from "../../react/state-change-nested-value";
import {cnv}   from "../../utils/arr-path";
import {chain} from "../../utils/fs";

import {normalizeRotation} from "./common/normalize-rotation";
import {switchSize}        from "./common/switch-size";

export const getControls = ({adj, mode}) => ({
    crop: {
        selected: mode.value === "crop",
        toggle: () => mode.change((m) => m === "crop" ? null : "crop"),
    },
    mask: (() => {
        return {
            active: adj.value?.mask?.url,
            selected: mode.value === "mask",
            toggleMode: (_) => mode.change((mode) => mode === "mask" ? null : "mask"),
        };
    })(),

    mode: {
        current: mode.value,
        clear: () => mode.change(() => null),
    },

    rotate: () => {
        mode.onChange(null);
        scnv(adj, [], (a) => chain(
            a,
            (_) => cnv(_, ["image", "rotation"], (r) => normalizeRotation((r ?? 0) + 90)),
            (_) => cnv(_, ["mask", "rotation"], (r) => normalizeRotation((r ?? 0) + 90)),
            (_) => cnv(_, ["vpSize"], (size) => size && switchSize(size)),
            (_) => cnv(_, ["mask", "maskCutout"], (cutout) => !cutout?.vpSize ? cutout : {...cutout, vpSize: switchSize(cutout.vpSize)}),
        ));
    },

    flip: () => {
        mode.onChange(null);
        scnv(adj, [], (a) => chain(
            a,
            (_) => {
                const change = (obj) => (_) => chain(
                    _,
                    (_) => cnv(_, [obj, "rotation"], (r) => (
                        !r || r === 180 ? (
                            r
                        ) : (
                            normalizeRotation(r + 180)
                        )
                    )),
                    (_) => cnv(_, [obj, "flip"], (flip) => !flip),
                );
                return chain(
                    _,
                    change("image"),
                    change("mask"),
                );
            },
            // (_) => cnv(_, ["vpRect"], (r) => r && flipRect(r, getBoundarySize())),
        ));
    },

    reset: {
        canDo: adj.value != null,
        invoke: () => adj.change(() => null),
    },

    filter: (() => {
        return {
            active: adj.value?.image?.filter?.type != null,
            selected: mode.value === "filter",
            currentType: adj.value?.image?.filter?.type,
            toggleMode: (_) => mode.change((mode) => mode === "filter" ? null : "filter"),
        };
    })(),

    undo: {
        canDo: adj.canUndo,
        invoke: adj.undo,
    },
    redo: {
        canDo: adj.canRedo,
        invoke: adj.redo,
    },

    zoom: {
        current: adj.value?.frame?.scale ?? 1,
        onChange: (v) => scnv(adj, ["frame", "scale"], () => v),
        canZoomIn: true,
        zoomIn : () => scnv(adj, ["frame", "scale"], (s) => (s??1)*1.1),
        zoomOut: () => scnv(adj, ["frame", "scale"], (s) => (s??1)/1.1),
        canZoomOut: true,
    },
});